/* Turning nav menu to open on hover instead of click */
const items = document.querySelectorAll(".header__inline-menu details");
const header = document.querySelector(".header");

const OPEN_SWITCH_DELAY = 120; // ms to wait before switching to a different menu
const CLOSE_DELAY = 200; // ms grace period before closing after the cursor leaves
let openTimer;
let closeTimer;

function anyMenuOpen() {
  return Array.from(items).some((el) => el.hasAttribute("open"));
}

function openMenu(item) {
  items.forEach((el) => {
    if (el !== item) el.removeAttribute("open");
  });
  item.setAttribute("open", true);
  header.classList.add("show");
}

function closeAllMenus() {
  items.forEach((el) => {
    if (!el.hasAttribute("open")) return;
    el.removeAttribute("open");

    // menu content not closing in Safari - this forces a reflow
    const megaMenuContent = el.querySelector("div.mega-menu__content");
    if (megaMenuContent) {
      void megaMenuContent.offsetHeight;
    }
  });
  header.classList.remove("show");
}

items.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (item.hasAttribute("open")) return;

    if (anyMenuOpen()) {
      // Switching menus: wait for intent so a quick clip doesn't swap menus.
      openTimer = setTimeout(() => openMenu(item), OPEN_SWITCH_DELAY);
    } else {
      openMenu(item);
    }
  });

  item.addEventListener("mouseleave", () => {
    clearTimeout(openTimer);
    closeTimer = setTimeout(closeAllMenus, CLOSE_DELAY);
  });

  const detailsChild = item.querySelector("summary");
  detailsChild.addEventListener("focus", () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    openMenu(item);
  });
});

document.querySelectorAll('nav header-menu [id^="Details-"] summary').forEach((summary) => {
  summary.addEventListener("click", (event) => {
    const spanDataHref = event.currentTarget.querySelector("span").getAttribute("data-href");
    const nameOfCollection = spanDataHref?.split("/")[2];
    const isUkReferrer = document.referrer.includes(".co.uk");
    const UKReferrerCookie = document.cookie.split("; ").find((row) => row.startsWith("UKReferrer=true"));
    const currentUrl = new URL(window.location.href);
    if ((isUkReferrer || UKReferrerCookie) && currentUrl.hostname.includes("fashionphile.com")) {
      window.location.replace(spanDataHref);
    } else {
      window.location.replace(`https://${window.location.host}/collections/${nameOfCollection}`);
    }
  });
});
